




// import React from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
// } from "react-leaflet";
// import MarkerClusterGroup from "react-leaflet-markercluster";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import "leaflet.markercluster/dist/MarkerCluster.css";
// import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// // INDIA CITY LIST
// // INDIA CITY LIST
// const cities = [
//   { name: "Pune", lat: 18.5204, lng: 73.8567 },
//   { name: "Mumbai", lat: 19.076, lng: 72.8777 },
//   { name: "Delhi", lat: 28.7041, lng: 77.1025 },
//   { name: "Bangalore", lat: 12.9716, lng: 77.5946 },
//   { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 }, // Added here as 5th
//   { name: "Chennai", lat: 13.0827, lng: 80.2707 },
//   { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
//   { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
//   { name: "Vadodara", lat: 22.3072, lng: 73.1812 },
//   { name: "Indore", lat: 22.7196, lng: 75.8577 },
//   { name: "Bhopal", lat: 23.2599, lng: 77.4126 },
//   { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
//   { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
//   { name: "Goa", lat: 15.2993, lng: 74.124 },
//   { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
//   { name: "Surat", lat: 21.1702, lng: 72.8311 },
//   { name: "Patna", lat: 25.5941, lng: 85.1376 },
// ];

// // CUSTOM MARKER ICON
// const markerIcon = new L.Icon({
//   iconUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
//   iconSize: [28, 45],
//   iconAnchor: [12, 41],
// });

// export default function NetworkMapPremium() {
//   return (
//     <>
     
//       <header className="cu-hero">
//         <div className="cu-hero__overlay" />
//         <div className="container">
//           <div className="cu-hero__content">
           
//             <div>
//               <h1 className="text-center">Our Premium Network Across India</h1>
// <p className="text-center invisible-text">
//   Travel with Luxury and Comfort
// </p>
//             </div>
//           </div>
//         </div>
//         <div className="cu-hero__curve" />
//       </header>

//       {/* ==== MAIN CONTENT SECTION ==== */}
//       <div
//         style={{
//           display: "flex",
//           maxWidth: "1400px",
//           margin: "40px auto",
//           gap: "30px",
//           padding: "20px",
//         }}
//       >
//         {/* LEFT: MAP */}
//         <div
//           style={{
//             flex: 2,
//             borderRadius: "20px",
//             overflow: "hidden",
//             boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
//             backdropFilter: "blur(6px)",
//           }}
//         >
//           <MapContainer
//             center={[22.9734, 78.6569]}
//             zoom={5}
//             scrollWheelZoom={true}
//             style={{ height: "600px", width: "100%" }}
//           >
//             <TileLayer
//               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//               attribution="© OpenStreetMap"
//             />

//             {/* MARKER CLUSTERING */}
//             <MarkerClusterGroup>
//               {cities.map((city, i) => (
//                 <Marker
//                   key={i}
//                   position={[city.lat, city.lng]}
//                   icon={markerIcon}
//                 >
//                   <Popup>
//                     <b style={{ fontSize: "16px" }}>{city.name}</b>
//                   </Popup>
//                 </Marker>
//               ))}
//             </MarkerClusterGroup>
//           </MapContainer>
//         </div>

//         {/* RIGHT: CITY LIST */}
//         <div
//           style={{
//             flex: 1,
//             background: "white",
//             padding: "25px",
//             borderRadius: "20px",
//             boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//             height: "600px",
//             overflowY: "auto",
//           }}
//         >
//           <h3
//             style={{
//               marginBottom: "20px",
//               fontWeight: "700",
//               fontSize: "26px",
//               color: "#0d47a1",
//             }}
//           >
//             Our Service Cities
//           </h3>

//           {/* CITY LIST */}
//           <ul style={{ padding: 0, listStyle: "none" }}>
//             {cities.map((city, index) => (
//               <li
//                 key={index}
//                 style={{
//                   padding: "12px 15px",
//                   marginBottom: "10px",
//                   borderRadius: "12px",
//                   background: "#f5f7fa",
//                   cursor: "pointer",
//                   fontWeight: "500",
//                   fontSize: "18px",
//                   color: "#333",
//                   transition: "0.3s",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.background = "#e3f2fd")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.background = "#f5f7fa")
//                 }
//               >
//                 📍 {city.name}
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// }












import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

/* =======================
   CITY DATA
======================= */
const cities = [
  { name: "Pune", lat: 18.5204, lng: 73.8567 },
  { name: "Mumbai", lat: 19.076, lng: 72.8777 },
  { name: "Delhi", lat: 28.7041, lng: 77.1025 },
  { name: "Bangalore", lat: 12.9716, lng: 77.5946 },
  { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 },
  { name: "Chennai", lat: 13.0827, lng: 80.2707 },
  { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
  { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
  { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
  { name: "Indore", lat: 22.7196, lng: 75.8577 },
  { name: "Bhopal", lat: 23.2599, lng: 77.4126 },
  { name: "Surat", lat: 21.1702, lng: 72.8311 },
  { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
  { name: "Goa", lat: 15.2993, lng: 74.124 },
];

/* =======================
   CUSTOM BLUE PIN ICON
======================= */
const bluePin = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [30, 46],
  iconAnchor: [15, 46],
  popupAnchor: [0, -40],
  shadowSize: [41, 41],
});

/* =======================
   COMPONENT
======================= */
export default function NetworkMapPremium() {
  return (
    <>
      {/* HERO */}
      <header className="cu-hero">
        <div className="cu-hero__overlay" />
        <div className="container">
          <div className="cu-hero__content">
            <div>
              <h1 className="text-center">Our Premium Network Across India</h1>
              <p className="text-center">Travel with Luxury and Comfort</p>
            </div>
          </div>
        </div>
        <div className="cu-hero__curve" />
      </header>

      {/* MAIN SECTION */}
      <div
        style={{
          display: "flex",
          maxWidth: "1400px",
          margin: "40px auto",
          gap: "30px",
          padding: "20px",
        }}
      >
        {/* MAP */}
        <div
          style={{
            flex: 2,
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          }}
        >
          <MapContainer
            center={[22.9734, 78.6569]}
            zoom={5}
            style={{ height: "600px", width: "100%" }}
            scrollWheelZoom
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="© OpenStreetMap contributors"
            />

            {/* SINGLE MARKERS (NO CLUSTER) */}
            {cities.map((city, index) => (
              <Marker
                key={index}
                position={[city.lat, city.lng]}
                icon={bluePin}
              >
                <Popup>
                  <strong style={{ fontSize: "15px" }}>
                    {city.name}
                  </strong>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        {/* CITY LIST */}
        <div
          style={{
            flex: 1,
            background: "#fff",
            padding: "25px",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            height: "600px",
            overflowY: "auto",
          }}
        >
          <h3
            style={{
              marginBottom: "20px",
              fontWeight: "700",
              fontSize: "26px",
              color: "#0d47a1",
            }}
          >
            Our Service Cities
          </h3>

          <ul style={{ padding: 0, listStyle: "none" }}>
            {cities.map((city, index) => (
              <li
                key={index}
                style={{
                  padding: "12px 15px",
                  marginBottom: "10px",
                  borderRadius: "12px",
                  background: "#f5f7fa",
                  fontSize: "18px",
                }}
              >
                📍 {city.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
